import Login from '@/auth/views/Login.vue';
import Register from '@/auth/views/Register.vue';
import ForgotPassword from '@/auth/views/ForgotPassword.vue';
import ResetPassword from '@/auth/views/ResetPassword.vue';
import EmailVerify from '@/auth/views/EmailVerify.vue';
import InviteUser from '@/auth/views/InviteUser.vue';
import Logout from '@/auth/views/Logout.vue';
import MyAccount from '@/auth/views/MyAccount.vue';
import MyAccountPersonalInformation from '@/auth/views/my-account/PersonalInformation.vue';
import MyAccountPassword from '@/auth/views/my-account/Password.vue';
import MyAccountOrganizationInformation from '@/auth/views/my-account/OrganizationInformation.vue';
import MyAccountTokens from '@/auth/views/my-account/Tokens.vue';
import MyAccountUsersList from '@/auth/views/my-account/UsersList.vue';
import MyAccountUserInvite from '@/auth/views/my-account/UserInvite.vue';
import MyAccountUserEdit from '@/auth/views/my-account/UserEdit.vue';

const routes = [
  {
    path: '/login',
    name: 'Auth-Login',
    component: Login,
    props: true,
    meta: {
      guest: true,
    },
  },
  {
    path: '/register',
    name: 'Auth-Register',
    component: Register,
    meta: {
      guest: true,
    },
  },
  {
    path: '/forgot-password',
    name: 'Auth-Forgot-Password',
    component: ForgotPassword,
    meta: {
      guest: true,
    },
  },
  {
    path: '/password/reset/:token',
    name: 'Auth-Reset-Password',
    component: ResetPassword,
    meta: {
      guest: true,
    },
  },
  {
    path: '/api/password/reset/:token',
    name: 'Auth-Reset-Password2',
    component: ResetPassword,
    meta: {
      guest: true,
    },
  },
  {
    path: '/invite/:token',
    name: 'Auth-Invite-User',
    component: InviteUser,
    meta: {
      guest: true,
    },
  },
  {
    path: '/email/verify/:firstToken/:secondToken',
    name: 'Auth-Email-Verify',
    component: EmailVerify,
    meta: {
      guest: true,
    },
  },
  {
    path: '/logout',
    name: 'Auth-Logout',
    component: Logout,
  },
  {
    path: '/my-account',
    name: 'Auth-My-Account',
    component: MyAccount,
    children: [
      {
        path: 'personal-information',
        name: 'Auth-My-Account-Personal-Information',
        component: MyAccountPersonalInformation,
        meta: {
          title: 'Informações Pessoais',
          subtitle: 'Nesta tela você visualiza e atualiza seus dados pessoais.',
        },
      },
      {
        path: 'password',
        name: 'Auth-My-Account-Password',
        component: MyAccountPassword,
        meta: {
          title: 'Senha',
          subtitle: 'Preencha os campos caso queira definir uma nova senha',
        },
      },
      {
        path: 'organization-information',
        name: 'Auth-My-Account-Organization-Information',
        component: MyAccountOrganizationInformation,
        meta: {
          title: 'Informações da Empresa',
          subtitle: 'Nesta tela você visualiza e atualiza os dados da sua empresa.',
        },
      },
      {
        path: 'tokens',
        name: 'Auth-My-Account-Tokens',
        component: MyAccountTokens,
        meta: {
          title: 'Tokens',
          subtitle: 'Nesta tela você visualiza os tokens associados à sua conta, para utilizar em pesquisas por API.',
        },
      },
      {
        path: 'users',
        name: 'Auth-My-Account-Users-List',
        component: MyAccountUsersList,
        meta: {
          title: 'Usuários',
          subtitle: 'Nesta tela você visualiza os usuários associados à sua empresa.',
          createRoute: {
            name: 'Auth-My-Account-User-Invite',
          },
        },
      },
      {
        path: 'user-invite',
        name: 'Auth-My-Account-User-Invite',
        component: MyAccountUserInvite,
        meta: {
          title: 'Criação de usuário',
          subtitle: 'Nesta tela você pode adicionar usuários associados à sua empresa.',
        },
      },
      {
        path: 'user-edit',
        name: 'Auth-My-Account-User-Edit',
        component: MyAccountUserEdit,
        meta: {
          title: 'Alterar permissão do usuário',
          subtitle: 'Nesta tela você pode alterar a permissão do usuário.',
        },
      },
    ],
  },
];

export default routes;
